import {useCallback} from 'react';
import {ROUTES} from '@/utils/constants/routesConstants';

export const useDisplayContentNavigation = (
  navigate,
  isLinkedTargetType,
  isRackChallenge,
  isEdit,
  disableDraft,
  editPublishedBeforeStart,
  salesTargetId,
  isCdaSuperTarget = false
) => {
  const skipsProductsStep =
    isLinkedTargetType || isRackChallenge || isCdaSuperTarget;

  const handleNextAction = useCallback(
    (persistDisplayContentToRedux) => {
      persistDisplayContentToRedux();
      const route = skipsProductsStep
        ? ROUTES.SALES_TARGET_REVIEW
        : ROUTES.SALES_TARGET_PRODUCTS;
      navigate(route, {
        state: {
          isEdit,
          disableDraft,
          editPublishedBeforeStart,
          salesTargetId: salesTargetId
        }
      });
    },
    [
      skipsProductsStep,
      navigate,
      isEdit,
      disableDraft,
      editPublishedBeforeStart,
      salesTargetId
    ]
  );

  const handleStepClick = useCallback(
    (persistDisplayContentToRedux, step) => {
      persistDisplayContentToRedux();
      const stepRouteMap = skipsProductsStep
        ? {1: ROUTES.SALES_TARGET_ADD, 3: ROUTES.SALES_TARGET_REVIEW}
        : {
            1: ROUTES.SALES_TARGET_ADD,
            3: ROUTES.SALES_TARGET_PRODUCTS,
            4: ROUTES.SALES_TARGET_REVIEW
          };
      const route = stepRouteMap[step];
      if (route)
        navigate(route, {
          state: {
            isEdit,
            disableDraft,
            editPublishedBeforeStart,
            salesTargetId
          }
        });
    },
    [
      skipsProductsStep,
      navigate,
      isEdit,
      disableDraft,
      editPublishedBeforeStart,
      salesTargetId
    ]
  );

  return {handleNextAction, handleStepClick};
};
